import LineChart from "../../../../components/LineChart/LineChart";
import { useState, useEffect, useCallback } from "react";
import {
  getToken,
  getRangeDates,
  formatDateTime,
  getDayOfWeekInSpanish,
} from "../../../../utils/utils";
import axios from "axios";
import { ENDPOINT } from "../../../../constants/endpointConstants";

export const InsightAverageTicket = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [originalData, setOriginalData] = useState(null);

  const chartOptions = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: function (context) {
            const index = context[0].dataIndex;
            const originalDate = originalData[index].date;
            const [, month, day] = originalDate.split("-");
            const dayOfWeek = getDayOfWeekInSpanish(originalDate);
            return `${dayOfWeek} ${day}-${month}`;
          },
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toLocaleString();
            }
            return label;
          },
        },
      },
    },
  };

  const getAverageTicketData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );
      const requestBody = {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      };
      const { data } = await axios.post(
        ENDPOINT.POST_AVERAGE_TICKET,
        requestBody,
        token
      );
      setOriginalData(data.data);
      const chartData = {
        labels: data.data.map((item) => {
          const [year, month, day] = item.date.split("-");
          return `${day}-${month}-${year.slice(2)}`;
        }),
        datasets: [
          {
            label: "Ticket",
            data: data.data.map((item) => item.averageOrderValue),
            borderColor: "rgb(75, 192, 192)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
          },
        ],
      };
      setData(chartData);
    } catch (err) {
      console.error("Error fetching average ticket data:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      getAverageTicketData();
    }
  }, [startDate, endDate, getAverageTicketData]);

  return (
    <div>
      {loading && <div>Cargando...</div>}
      {error && <div>Error</div>}
      {data && <LineChart data={data} options={chartOptions} />}
    </div>
  );
};

export default InsightAverageTicket;
